import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Practice } from 'src/app/interfaces/practice';
import { PracticeInscription } from 'src/app/interfaces/practiceinscription';
import { ErrorService } from 'src/app/services/error.service';
import { PracticeService } from 'src/app/services/practice.service';
import { PracticeInscriptionService } from 'src/app/services/practiceinscription.service';

@Component({
  selector: 'app-practice',
  templateUrl: './practice.component.html',
  styleUrls: ['./practice.component.css']
})
export class PracticeComponent implements OnInit {
  listPractices: Practice[] = [];
  loading = false;

  constructor(
    private _practiceService: PracticeService,
    private _practiceInscriptionService: PracticeInscriptionService,
    private toastr: ToastrService,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.getListPractices2();
  }

  getListPractices2() {
    this.loading = true;
    this._practiceService.getListPractices().subscribe({
      next: (data: Practice[]) => {
        this.listPractices = data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener la lista de practicas:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deletePractice(id: number) {
    this.loading = true;

    this._practiceInscriptionService.getPracticeInscriptionsByPracticeId(id).subscribe({
      next: (inscriptions: PracticeInscription[]) => {
        if (inscriptions.length > 0) {
          this.toastr.error(
            'No se puede eliminar la practica porque tiene inscripciones asociadas',
            'Error'
          );
          this.loading = false;
          return;
        }

        this._practiceService.deletePractice(id).subscribe({
          next: () => {
            this.getListPractices2();
            this.toastr.warning('La practica fue eliminada con exito', 'Practica eliminada');
          },
          error: (error) => {
            console.error('Error al eliminar la practica:', error);
            this._errorService.msjError(error);
            this.loading = false;
          }
        });
      },
      error: (error) => {
        console.error('Error al verificar las inscripciones asociadas:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deletePractice2(id: number) {
    this.deletePractice(id);
  }

  updatePracticeState(id: number, state: number) {
    const newStatus = state === 0 ? 1 : 0;
    this.loading = true;

    this._practiceService.updatePracticeState(id, { state: newStatus }).subscribe({
      next: () => {
        this.getListPractices2();
        const practiceMessage = newStatus === 0 ? 'deshabilitada' : 'habilitada';
        this.toastr.warning(`La practica fue ${practiceMessage} con exito`, 'Practica actualizada');
      },
      error: (error) => {
        console.error('Error al actualizar el estado de la practica:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  habilitarPracticasMasivo() {
    this.loading = true;
    this._practiceService.habilitarDeshabilitarPracticasMasivo().subscribe({
      next: () => {
        this.getListPractices2();
      },
      error: (error) => {
        console.error('Error al habilitar practicas:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deshabilitarPracticasMasivo() {
    this.loading = true;
    this._practiceService.deshabilitarDeshabilitarPracticasMasivo().subscribe({
      next: () => {
        this.getListPractices2();
      },
      error: (error) => {
        console.error('Error al deshabilitar practicas:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }
}
